/**
 * Field-type icons for column headers — matches the small grey glyph
 * Airtable shows next to each column name (text, #, calendar, …).
 */

import React from 'react';
import {
  TextFieldsRounded,
  NumbersRounded,
  AttachMoneyRounded,
  PercentRounded,
  CalendarMonthRounded,
  ScheduleRounded,
  CheckBoxRounded,
  LocalOfferRounded,
  StyleRounded,
  TagRounded,
  AlternateEmailRounded,
  LinkRounded,
  DataObjectRounded,
  NotesRounded,
  HelpOutlineRounded,
} from '@mui/icons-material';
import type { FieldType } from './types';

const ICON_MAP: Record<FieldType, React.ComponentType<{ sx?: any }>> = {
  text: TextFieldsRounded,
  long_text: NotesRounded,
  number: NumbersRounded,
  currency: AttachMoneyRounded,
  percent: PercentRounded,
  date: CalendarMonthRounded,
  datetime: ScheduleRounded,
  boolean: CheckBoxRounded,
  categorical: LocalOfferRounded,
  multi_select: StyleRounded,
  id: TagRounded,
  email: AlternateEmailRounded,
  url: LinkRounded,
  json: DataObjectRounded,
  null: HelpOutlineRounded,
};

export function FieldTypeIcon({ type, sx }: { type: FieldType; sx?: any }) {
  const Cmp = ICON_MAP[type] || TextFieldsRounded;
  return <Cmp sx={sx} />;
}
